import { AuthLayout } from 'components/Global/AuthLayout';
import GlobalLayout from 'layouts/Global';
import {
	ForgotPassword,
	Home,
	//Login,
	OutsetaLogin,
	ResetPassword,
	ThankYouPage,
	TimeActivity,
} from 'pages';
import CostAllocationPage from 'pages/CostAllocation';
import EmployeeCosts from 'pages/EmployeeCosts';
import ExpenseAllocation from 'pages/ExpenseAllocation/index';
import QuickbooksCallback from 'pages/QuickbooksCallback';
import Unauthorized from 'pages/Unauthorized';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import JournalEntries from 'pages/JournalEntries';
import Reports from 'pages/Reports';
import QuickbooksSSOCallback from 'pages/QuickbooksSSOCallback';
import QuickbooksLaunchCallback from 'pages/QuickbooksLaunchCallback';
import QuickbooksDisconnectCallback from 'pages/QuickbooksDisconnectCallback';
import QuickbooksAppInstallCallback from 'pages/QuickbooksAppInstallCallback';
import Chat from 'pages/Chat';

const router = createBrowserRouter([
	{
		element: <AuthLayout />,
		children: [
			{
				path: '/',
				element: <GlobalLayout />,
				children: [
					{
						// The dashboard and the assistant are separate pages now, so
						// "/" belongs to neither. Redirecting rather than rendering
						// the dashboard here keeps one URL per page — and every
						// existing navigate('/') in the app (Quickbooks callbacks,
						// login, registration) still lands somewhere real.
						index: true,
						element: <Navigate to="/dashboard" replace />,
					},
					{
						path: 'dashboard',
						element: <Home />,
					},
					{
						path: 'chat',
						element: <Chat />,
					},
					{
						path: 'time-activity',
						element: <TimeActivity />,
					},
					{
						path: 'employee-costs',
						element: <EmployeeCosts />,
					},
					{
						path: 'cost-allocations',
						element: <CostAllocationPage />,
					},
					{
						path: 'expense-allocations',
						element: <ExpenseAllocation />,
					},
					{
						path: 'journal-entries',
						element: <JournalEntries />,
					},
					{
						path: 'reports',
						element: <Reports />,
					},
				],
			},
			// {
			// 	path: '/login',
			// 	element: <Login />,
			// },
			{
				path: '/login',
				element: <OutsetaLogin />,
			},
			{
				path: '/thankYou',
				element: <ThankYouPage />,
			},
			{
				path: '/reset-password',
				element: <ResetPassword />,
			},
			{
				path: '/forgot-password',
				element: <ForgotPassword />,
			},
			{
				path: '/callback',
				element: <QuickbooksCallback />,
			},
			{
				path: '/sso-callback',
				element: <QuickbooksSSOCallback />,
			},
			{
				path: '/launch-callback',
				element: <QuickbooksLaunchCallback />,
			},
			{
				path: '/disconnect-callback',
				element: <QuickbooksDisconnectCallback />,
			},
			{
				path: '/install-app-from-quickbooks',
				element: <QuickbooksAppInstallCallback />,
			},
			{
				path: '/unauthorized',
				element: (
					<Unauthorized
						status={401}
						title="Unauthorized"
					/>
				),
			},
			{
				path: '*',
				element: (
					<Unauthorized
						status={404}
						title="Page Not Found"
					/>
				),
			},
		],
	},
]);

export default router;
